<!-- Regular - matches the height and label placement of a mat-form-field, so it sits in a column
     of standard inputs. The hidden input is what makes mat-form-field accept the content. -->
@if (on === 'form' && !field.condensed) {
  <!-- The real input is hidden, so Material would read the field as empty and leave the label
       sitting over the value like a placeholder. Floating it always keeps the field looking the
       same whether or not something has been picked. -->
  <mat-form-field class="full-width" style="height: 74px" floatLabel="always">
    <mat-label>{{field.label}}</mat-label>
    <input type="text" matInput [formControl]="control" style="display:none">
    @if (field.getUrl()) {
      <a [routerLink]="field.getUrl()" [attr.data-field]="field?.name">{{field.displayText}}</a>
    } @else if (field.displayText) {
      <span [attr.data-field]="field?.name">{{field.displayText}}</span>
    } @else {
      <span class="pick-link-empty" [attr.data-field]="field?.name" i18n>Not set</span>
    }
    <!-- One suffix holding both icons - as separate matSuffix elements Material spaces them apart -->
    <div matSuffix class="pick-link-suffix">
      @if (editable) {
        <mat-icon color="primary" [attr.data-field-name]="field?.name" (click)="openPicker()"
          [matTooltip]="chooseTip" matTooltipPosition="above">edit</mat-icon>
      }
      @if (showClear) {
        <mat-icon color="warn" (click)="clear()"
          [matTooltip]="clearTip" matTooltipPosition="above">delete</mat-icon>
      }
    </div>
    <mat-error style="margin-top: -5px">
      <app-form-error [control]="control"></app-form-error>
    </mat-error>    
  </mat-form-field>
}
<!-- Condensed - display only, matching the other condensed fields. Editing is done through
     the section edit dialogs, never inline here. -->
@if (on === 'form' && field.condensed) {
  <div class="pick-link-row">
    <div class="condensed-label">{{field.label}}</div>
    <div class="pick-link-value">
      @if (field.getUrl()) {
        <a [routerLink]="field.getUrl()" [attr.data-field]="field?.name">{{field.displayText}}</a>
      } @else if (field.displayText) {
        <span [attr.data-field]="field?.name">{{field.displayText}}</span>
      } @else {
        <span class="pick-link-empty" [attr.data-field]="field?.name" i18n>Not set</span>
      }
    </div>
    <div class="condensed-hint">
      @if (field.hint) {
        <mat-icon [matTooltip]="field.hint" matTooltipPosition="above">help</mat-icon>
      }
    </div>
  </div>
}
<!-- Grid cell. Editable where the field allows it, so a pick-link can be a column a user fills in
     rather than only a column they read. The picker resolves its tenant through getCurrentItem(),
     which in a grid reads the row - so a row needing a forced team carries FieldMaker.idHolder for
     whichever key forceTeamId names, the way the request budget grid carries teamId. -->
@if (on !== 'form') {
  <div class="pick-link-cell-row">
    @if (field.getUrl()) {
      <a [routerLink]="field.getUrl()" class="pick-link-cell" [attr.data-field]="field?.name">{{field.displayText}}</a>
    } @else if (field.displayText) {
      <span class="pick-link-cell" [attr.data-field]="field?.name">{{field.displayText}}</span>
    } @else {
      <span class="pick-link-cell pick-link-empty" [attr.data-field]="field?.name" i18n>Not set</span>
    }
    @if (editable) {
      <mat-icon color="primary" [attr.data-field-name]="field?.name" (click)="openPicker()"
        [matTooltip]="chooseTip" matTooltipPosition="above">edit</mat-icon>
    }
  </div>
}
